var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 9,
    viewBox: "0 0 22 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5878 7.76709C4.76454 6.48254 0.26863 4.38445 0.568357 3.09991C0.868083 1.77255 5.83499 1.72973 11.6583 3.01427C17.4815 4.29882 21.9774 6.3969 21.6777 7.72427C21.378 9.05163 16.4539 9.05163 10.5878 7.76709Z",
    fill: "url(#paint0_linear_1_266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6307 7.68169C5.36405 6.5256 1.33915 4.64161 1.59606 3.4427C1.85296 2.28661 6.30604 2.24379 11.5727 3.39988C16.7965 4.55597 20.8642 6.43997 20.6073 7.63888C20.3504 8.79497 15.8973 8.83778 10.6307 7.68169Z",
    fill: "url(#paint1_linear_1_266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6073 7.55287C20.6073 7.58141 20.6073 7.60996 20.6073 7.6385C20.3504 8.79459 15.8973 8.83741 10.6307 7.68132C5.36405 6.52523 1.33915 4.64123 1.59606 3.44233C1.59606 3.41378 1.61032 3.39951 1.63887 3.39951C1.51042 4.55559 5.4925 6.39678 10.6735 7.55287C15.8117 8.66614 20.1791 8.66614 20.6073 7.55287V7.55287Z",
    fill: "#A86314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9572 1.72976C17.7804 3.0143 22.2763 5.11239 21.9766 6.39693L21.6769 7.72429C21.9766 6.39693 17.4807 4.29884 11.6574 3.0143C5.83417 1.72976 0.867262 1.77257 0.567535 3.09994L0.867261 1.77258C1.16699 0.445216 6.09108 0.445213 11.9572 1.72976Z",
    fill: "url(#paint2_linear_1_266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_266",
    x1: 23.5189,
    y1: 5.62618,
    x2: 22.4912,
    y2: 10.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_266",
    x1: 23.2192,
    y1: 3.52833,
    x2: 21.2496,
    y2: 10.7646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_266",
    x1: 1.20981,
    y1: -2.03824,
    x2: 23.8606,
    y2: 2.97149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin14);
export default __webpack_public_path__ + "static/media/coin14.1f4a4495bb7bb30746c1d3e41143e1b1.svg";
export { ForwardRef as ReactComponent };